import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import withWidgetTestId from '@swf/core/hoc/withWidgetTestId';
import { select } from '@swf/core/store';
import type { WidgetFC } from '@swf/core/types/Widget';

import {
  TXTCLI_General,
  TXTWCL_Automatically_accept_price_cha_ELL,
  TXTWCL_Bet_Slip,
  TXTWCL_Odds_Type
} from './SportsSettingsWidget.messages.json';
import styles from './SportsSettingsWidget.scss';
import AutoAcceptPriceSelector from './components/AutoAcceptPriceSelector/AutoAcceptPriceSelector';
import OddsFormatSelector from './components/OddsFormatSelector/OddsFormatSelector';

const SportsSettingsWidget: WidgetFC = () => {
  const isClientAuthenticated = useSelector(select.session.isClientAuthenticated);

  return (
    <section>
      <div className={styles.setting}>
        <h2 className={styles.heading}>
          <Translation {...TXTCLI_General} />
        </h2>
        <h3 className={styles.subheading}>
          <Translation {...TXTWCL_Odds_Type} />
        </h3>
        <OddsFormatSelector />
      </div>

      {isClientAuthenticated && (
        <div className={styles.setting}>
          <h2 className={styles.heading}>
            <Translation {...TXTWCL_Bet_Slip} />
          </h2>
          <h3 className={styles.subheading}>
            <Translation {...TXTWCL_Automatically_accept_price_cha_ELL} />
          </h3>
          <AutoAcceptPriceSelector />
        </div>
      )}
    </section>
  );
};

export default withWidgetTestId(SportsSettingsWidget, 'sports-settings', {
  className: styles.layout
});
